import React from 'react'
import styled from 'styled-components'
import { mediaQueries, palette } from '@centivo/react-components'
import { Content as RefContent, ContentSection } from 'src/refactor/structure'
import underConstruction from 'src/assets/Images/under-construction.svg'
import dashedLine from 'src/assets/Images/backgrounds/eligibility-dashed-line.svg'
import dashedLineMobile from 'src/assets/Images/backgrounds/eligibility-dashed-line-mobile.svg'

const Container = styled(RefContent)`
  background: url(${dashedLineMobile}) 0 100%/100% no-repeat;
  display: flex;
  flex-grow: 1;

  @media ${mediaQueries.desktop} {
    background-image: url(${dashedLine});
  }
`

const Content = styled(ContentSection)`
  padding: 0.5rem 2rem 0;
  text-align: center;

  img {
    margin-bottom: 2.5rem;
  }

  h2 {
    font-size: 2.5rem;
    line-height: 1.3;
    font-weight: 700;
    color: ${palette.brand.purple};

    @media ${mediaQueries.desktop} {
      font-size: 3.25rem;
      line-height: 1;
      margin-bottom: 0.75rem;
    }
  }

  p {
    font-size: 1.25rem;
    font-weight: 600;
    color: #59616e;

    @media ${mediaQueries.desktop} {
      font-size: 1.5rem;
    }
  }
`

export const UnderConstruction: React.FC = () => {
  return (
    <Container>
      <Content>
        <img src={underConstruction} alt="Coming Soon" />
        <h2>Coming soon</h2>
        <p>
          Our website is currently undergoing maintenance.
          <br />
          Thank you for your patience.
        </p>
      </Content>
    </Container>
  )
}
